import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { valueStack, valuePriced, valueTotals, offers, media } from '../data/product';
import { CtaButton } from './CtaButton';
import { GuaranteeBadge, ShopHotspot } from './BannerOverlays';
export function ValueStackSection() {
  return <section aria-labelledby="value-heading" className="border-b border-white/10 bg-ink-950" data-id="element-967" data-mp="1hcoy0f2grso2">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-968" data-mp="tn4arjza298z">
        <h2 id="value-heading" className="grit-headline max-w-3xl text-[clamp(2.25rem,8vw,4rem)] font-extrabold uppercase text-offwhite" data-id="element-969" data-mp="oojcvr7i01np">
          The complete
          <br data-id="element-970" data-mp="12lzl989cu5i3" />
          <span className="text-grit-500" data-id="element-971" data-mp="ymz1nnj1yyu1">GritVue X1 system.</span>
        </h2>
        <p className="mt-4 max-w-2xl text-lg text-steel-300" data-id="element-972" data-mp="yp3foyao1e81">
          Built for real work. The GritVue X1™ combines hands-free illumination, interchangeable lenses and a
          complete care system in one premium, work-ready package.
        </p>

        <div className="mt-10 grid gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:items-start" data-id="element-973" data-mp="1nbx9ctp35dob">
          <div className="border border-white/12 bg-ink-900" data-id="element-974" data-mp="1sba19sutdaxr">
            <p className="border-b border-white/10 px-5 py-4 text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400 sm:px-6" data-id="element-975" data-mp="1wdn8klp7lgwn">
              Everything included
            </p>
            <ul data-id="element-976" data-mp="21anbwouoc5k2">
              {valuePriced.map(row => <li key={row.item} className="flex items-start justify-between gap-5 border-b border-white/5 px-5 py-4 sm:px-6" data-id="element-977" data-mp="14ns6rpk5zyr3">
                  <span className="min-w-0" data-id="element-978" data-mp="1dmx2yp897g03">
                    <span className="block text-base font-semibold text-offwhite sm:text-lg" data-id="element-979" data-mp="1dl2ifc0w9pwj">{row.item}</span>
                    <span className="mt-0.5 block text-[13px] text-steel-500" data-id="element-980" data-mp="1ifqblo6uf8hg">{row.note}</span>
                  </span>
                  <span className="shrink-0 text-right" data-id="element-981" data-mp="pxb8ug6qnqyy">
                    <span className="block font-display text-2xl font-bold leading-none text-steel-300" data-id="element-982" data-mp="pvrrem9cj9vl">
                      {row.price}
                    </span>
                    {row.price.startsWith('$') && <span className="mt-0.5 block text-[10px] font-bold uppercase tracking-[0.16em] text-steel-500" data-id="element-983" data-mp="1o7kt3tobpc0h">
                        Value
                      </span>}
                  </span>
                </li>)}
            </ul>

            <div className="flex items-center justify-between gap-5 border-b border-white/10 px-5 py-4 sm:px-6" data-id="element-984" data-mp="1a9w9sq9wmcxj">
              <span className="font-display text-xl font-bold uppercase tracking-wide text-offwhite" data-id="element-985" data-mp="15cmdqrs0f30q">
                Total separate value
              </span>
              <span className="font-display text-3xl font-extrabold leading-none text-offwhite" data-id="element-986" data-mp="1ea6c9syhml7n">
                {valueTotals.total}
              </span>
            </div>
            <div className="flex items-center justify-between gap-5 border-b border-white/10 px-5 py-4 sm:px-6" data-id="element-987" data-mp="2pqmutv5c9hyq">
              <span className="font-display text-xl font-bold uppercase tracking-wide text-steel-400" data-id="element-988" data-mp="2y75etia83f41">
                Regular complete system price
              </span>
              <span className="font-display text-3xl font-extrabold leading-none text-steel-400 line-through" data-id="element-989" data-mp="2o97is8m4ge0v">
                {valueTotals.regular}
              </span>
            </div>
            <div className="flex items-center justify-between gap-5 border-b border-white/10 bg-ink-850 px-5 py-4 sm:px-6" data-id="element-990" data-mp="2ta59j9l76gdz">
              <span className="font-display text-xl font-bold uppercase tracking-wide text-offwhite" data-id="element-991" data-mp="3lwpxs16dmcdb">
                You save from regular price
              </span>
              <span className="text-right" data-id="element-992" data-mp="375z8azs9bpdd">
                <span className="block font-display text-3xl font-extrabold leading-none text-grit-500" data-id="element-993" data-mp="3c6el9q8mmuut">
                  {valueTotals.saveOne}
                </span>
                <span className="mt-1 block text-[11px] font-bold uppercase tracking-[0.18em] text-grit-500" data-id="element-994" data-mp="8i33rtwrd9w3">
                  {valueTotals.discount}
                </span>
              </span>
            </div>

            <a href="#offer" className="group block bg-grit-500 px-5 py-6 text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px] focus:outline-none focus-visible:ring-2 focus-visible:ring-offwhite sm:px-6" data-id="element-995" data-mp="2c0azwwe32la8">
              <p className="text-[11px] font-bold uppercase tracking-[0.2em]" data-id="element-996" data-mp="2zq5g9nxm2rz8">This week&apos;s sale price</p>
              <p className="mt-2 flex flex-wrap items-end gap-x-4 gap-y-1" data-id="element-997" data-mp="2uqapdkdu62e6">
                <span className="font-display text-5xl font-extrabold leading-none sm:text-6xl" data-id="element-998" data-mp="2pzkj84xl5vif">
                  {valueTotals.payOne}
                </span>
                <span className="pb-1.5 font-display text-lg font-bold uppercase sm:text-xl" data-id="element-999" data-mp="2l0hdei9s7l9e">
                  for the complete system
                </span>
              </p>
              <p className="mt-3 font-display text-xl font-extrabold uppercase leading-tight sm:text-2xl" data-id="element-1000" data-mp="3domyj64qzc9r">
                Or as low as {valueTotals.payEach} per X1 with Buy 4, Get 2 Free.
              </p>
              <p className="mt-4 inline-flex items-center gap-2 font-display text-xl font-extrabold uppercase tracking-wide" data-id="element-1001" data-mp="3q0642x4yp79j">
                Choose your pack
                <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-grit group-hover:translate-x-1" aria-hidden="true" data-id="element-1002" data-mp="3sz6db073a0m" />
              </p>
            </a>
          </div>

          <div data-id="element-1003" data-mp="crjjlwmzkrhg">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-1004" data-mp="cr1c23uviqu8">In every box</p>
            <ul className="mt-4 max-w-md" data-id="element-1005" data-mp="hm6yd3s6u7iu">
              {valueStack.map(item => <li key={item} className="flex items-center gap-3 border-b border-white/10 py-3.5 text-base font-medium text-offwhite sm:text-lg" data-id="element-1006" data-mp="ml0c8xbe00jj">
                  <CheckIcon className="h-5 w-5 shrink-0 text-grit-500" aria-hidden="true" data-id="element-1007" data-mp="vhj5kanj5qgn" />
                  {item}
                </li>)}
            </ul>

            <figure className="mt-8 border border-white/10 bg-ink-900" data-id="element-1008" data-mp="2nmgasfxeqd83">
              <div className="relative" data-id="element-1009" data-mp="31ctkontv0202">
                <img src={media.detailSheet} alt="The GritVue X1 frame with its light module, clear, amber and smoke lenses and USB-C charging" className="block h-auto w-full" data-id="element-1010" data-mp="31duw4teseqib" />
                <GuaranteeBadge compact box={{
                left: '17.2%',
                top: '37.4%',
                width: '17.4%',
                height: '9.2%'
              }} data-id="element-1011" data-mp="36c65l3166z00" />
                <ShopHotspot box={{
                left: '3.3%',
                top: '38.4%',
                width: '14.2%',
                height: '7%'
              }} data-id="element-1012" data-mp="3k9bi9lve2w48" />
              </div>
              <figcaption className="border-t border-white/10 px-4 py-3 text-[13px] text-steel-400" data-id="element-1013" data-mp="1pxeq1qp4hm84">
                The X1 itself: illuminated frame, all three lenses and USB-C charging.
              </figcaption>
            </figure>

            <ul className="mt-6 grid grid-cols-1 gap-px bg-white/10 sm:grid-cols-3" data-id="element-1014" data-mp="1bsxjoeb9s3gw">
              {offers.map(offer => <li key={offer.id} data-id="element-1015" data-mp="1fsoin5ay9pwi">
                  <a href="#offer" aria-label={`${offer.units} for ${offer.price}. Go to pricing`} className={`block h-full px-4 py-4 transition-[background-color,transform] duration-150 ease-grit active:translate-y-[2px] focus:outline-none focus-visible:ring-2 focus-visible:ring-grit-500 ${offer.featured ? 'bg-grit-500 text-ink-950 hover:bg-grit-400' : 'bg-ink-900 hover:bg-ink-800'}`} data-id="element-1016" data-mp="12230jitbljzo">
                    <p className={`font-display text-xl font-extrabold uppercase leading-none ${offer.featured ? 'text-ink-950' : 'text-offwhite'}`} data-id="element-1017" data-mp="o1s48098rd74">
                      {offer.kicker}
                    </p>
                    <p className={`mt-1 font-display text-3xl font-extrabold leading-none ${offer.featured ? 'text-ink-950' : 'text-grit-500'}`} data-id="element-1018" data-mp="3r19zyvon77i1">
                      {offer.price}
                    </p>
                    <p className={`mt-1 text-[11px] font-bold uppercase tracking-wide ${offer.featured ? 'text-ink-950/70' : 'text-steel-400'}`} data-id="element-1019" data-mp="3d9viwueapgdm">
                      {offer.perUnit ?? offer.discountBadge ?? 'Single system'}
                    </p>
                  </a>
                </li>)}
            </ul>

            <p className="grit-headline mt-8 text-[clamp(1.75rem,6vw,3rem)] font-extrabold uppercase text-offwhite" data-id="element-1020" data-mp="2ubj710w01sec">
              See further.
              <br data-id="element-1021" data-mp="wilw4zoj5t57" />
              <span className="text-grit-500" data-id="element-1022" data-mp="sj4pw41a4ryz">Work smarter.</span>
            </p>
            <p className="mt-3 text-[15px] font-semibold uppercase tracking-wide text-steel-300" data-id="element-1023" data-mp="sh0hb8sfr4sd">
              Built for the people who keep America moving.
            </p>
            <p className="mt-1 text-[13px] text-steel-500" data-id="element-1024" data-mp="2fe9p5refrh25">RX Insert sold separately.</p>

            <CtaButton offer="trio" className="mt-6 w-full sm:w-auto" data-id="element-1025" data-mp="2k7uaojyueikg">
              Get 3 X1 Systems for $99.90
            </CtaButton>
          </div>
        </div>
      </div>
    </section>;
}